/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@vueform/toggle/themes/default.css";

// Composables
import { createVuetify } from "vuetify";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import { VItemGroup } from "vuetify/components";
import Toggle from "@vueform/toggle";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    ...labsComponents,
    VItemGroup,
    Toggle,
  },
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#1867C0",
          secondary: "#5CBBF6",
        },
      },
    },
  },
});
